import { Inject, Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, HttpProviderService, HttpRequest, RoutingInfo } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { DocumentUploadService } from "../documentupload-service/document-upload.service";
import { DocInfo } from "../documentupload-service/documentupload.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { map, Observable, of,catchError } from 'rxjs';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";
import { MobileService } from "src/app/mobile.services";
export class FilePreviewState extends BaseFpxComponentState {
    showSuggestion: boolean = false;
    data: any = {};
}

@Injectable()
export class FilePreviewHelper extends BaseFpxFormHelper<FilePreviewState>{
    title: string;
    constructor(
        public _commonService: CommonService,
        public _mobileService: MobileService,
        public _processShellService: ProcessShellService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        protected dom: DomSanitizer,
        private dialogRef: MatDialogRef<FilePreviewHelper>,
        private _httpProvider: HttpProviderService,
        private _fileOpener: FileOpenerService
    ) {
        super(new FilePreviewState());
    }

    public doPreInit(): void {
        if(this._commonService.getApplicationMode() == 'RM') {
            this.title = 'Documents'
        } 
        else {
            this.title = 'File preview'
        }
        this.state.data = this.data;
        this.setImageData();
    }

    public doDestroy(): void {
       this.dialogRef?.close(this.state.data)
    }

    closePreview() {
        this.dialogRef.close(this.state.data)
    }

    setImageData(){
        this.state.data.files.forEach((file, i) => {
            let checkFile = file.invNumber? file.file: file;
            if (typeof (checkFile) === 'object') {
                this._commonService.fileToBase64(checkFile).then(
                    (value) => {
                        if(file.type == "application/pdf" || file.name?.match(/.pdf$/gi)?.length == 1) this.state.data.files[i].imageSrc = './assets/images/pdf-icon.svg';
                        else this.state.data.files[i].imageSrc = value;
                    }
                )
            } else {
                this.state.data.files[i] = checkFile;
            }
        });
    }
    previewFile(i) {
        let documentURL = URL.createObjectURL(new Blob([this.state.data.files[i].file], { type: this.state.data.files[i].type }));
        const downloadLink = document.createElement('a');
        downloadLink.href = documentURL;
        const fileName = this.state.data.files[i].name;
        downloadLink.download = fileName;
        downloadLink.click();
            // let file = this.state.data.files[i]
            // const blob = new Blob([file], { type: file.type });
            // const url = URL.createObjectURL(blob);
            // window.open(url);
    }
    previewRmFile(i) {
        if(this.state.data.files[i].invNumber) {
            let blob = this.state.data.files[i].file
            const url = URL.createObjectURL(blob);
            window.open(url);
        } 
        else {
            let file = this.state.data.files[i]
            const blob = new Blob([file], { type: file.type });
            const url = URL.createObjectURL(blob);
            window.open(url);
        }
    }

    downloadFile(i) {
        let invNumber = this.state.data.files[i].invNumber;
        const fileName = this.state.data.files[i].name;
        let fileType =fileName.split('.')[1];
        let fileTypes:any;
        const httpRequest = new HttpRequest();
        httpRequest.setMethod('GET');
        httpRequest.setResource(`/documentdownload/${invNumber}`);
        httpRequest.addHeaderParamter('Appref', this._commonService.doEncrypt(this._processShellService.getProcessId()))
    
      
        return this._httpProvider.invokeDownloadApi(httpRequest).subscribe({
        next: (response:any) => {
            this._commonService.hideSpinner();
            if (this._commonService.isHybrid()  ) {
               
                switch(fileType){
                    case "jpg":
                        fileTypes = "image/jpeg";
                      break;
                    case "jpeg":
                        fileTypes = "image/jpeg";
                      break;
                      case "png":
                        fileTypes = "image/png";
                      break;
                      default :
                      fileTypes = "application/pdf";
                      break;
                }
              this._fileOpener.openPDF(
                response,
                fileTypes,
                fileName
              );
            } else {
              let documentURL = URL.createObjectURL(
                new Blob([response.body], { type: fileTypes })
              );
              const downloadLink = document.createElement("a");
              downloadLink.href = documentURL;
              const fileName = "TransactionDetails";
              downloadLink.download = fileName;
              downloadLink.click();
            }
        
          },
          error: (reason:any) => {
      
          },
        });
      }
    protected isDeleteRequired() {
        return this._processShellService.applicationStatus?.status == "DDE" || this._processShellService.applicationStatus?.status == "AddlDocmt";
    }
    onDelete(i) {
        this.state.data.files.splice(i,1);
        this.state.data.filesInvNumber.splice(i,1);
        if(this.state.data.files.length == 0) this.closePreview()
    }
    public preSubmitInterceptor(payload: any) {
        
        return payload;
    }

    public postSubmitInterceptor(response: BaseFpxPostSubmitInterceptor): RoutingInfo {
        let routingInfo:RoutingInfo=new RoutingInfo();
        // WRITE CODE HERE TO HANDLE 
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
       
        return routingInfo;
    }
}